import { __assign, __rest } from "tslib";
import React from 'react';
import { cnHeader } from '../Header.const';
import { Link } from '../../Link/Link';
import './Header-Nav.css';
/**
 * Компонент группировки навигационных табов.
 * @param {NavType} props
 *
 */
export var HeaderNav = function (_a) {
    var className = _a.className, children = _a.children, innerRef = _a.innerRef;
    return (React.createElement("nav", { ref: innerRef, className: cnHeader('Nav', [cnHeader('Item'), className]) }, children));
};
/**
 * Компонент навигационного таба.
 * @param {HeaderNavLinkProps} props
 *
 */
export var HeaderNavItem = function (_a) {
    var href = _a.href, active = _a.active, className = _a.className, icon = _a.icon, children = _a.children, rest = __rest(_a, ["href", "active", "className", "icon", "children"]);
    return (React.createElement(Link, __assign({}, rest, { className: cnHeader('NavLink', { active: active }, [className]), href: href }),
        icon,
        React.createElement("span", null, children)));
};
